export default {
    driverPerformanceFunctionTab_performanceImprovement_performanceImprovement: 'Performance Improvement',
    driverPerformanceFunctionTab_performanceImprovement_enableDefaultsPI: 'Enable Defaults PI',
    driverPerformanceFunctionTab_performanceImprovement_avgEvents: 'Avg Events',
    driverPerformanceFunctionTab_performanceImprovement_riskScore: 'Risk Score',
    driverPerformanceFunctionTab_performanceImprovement_events: 'Events',
    driverPerformanceFunctionTab_performanceImprovement_totalDistance: 'Total Distance',
    driverPerformanceFunctionTab_performanceImprovement_save: 'Save',
    driverPerformanceFunctionTab_performanceImprovement_success: 'Success',
    driverPerformanceFunctionTab_performanceImprovement_error: 'Error',
    driverPerformanceFunctionTab_performanceImprovement_updatedConfiguration: 'Configuration updated successfully',
    driverPerformanceFunctionTab_performanceImprovement_updatedConfigurationError: 'Error updating configuration',
    driverPerformanceFunctionTab_performanceImprovement_coachingEducationRequired: 'Coaching Education must be enabled before activating Performance Improvement',
    driverPerformanceFunctionTab_performanceImprovement_avgEventsTooltip: 'Range: 1-10000',
    driverPerformanceFunctionTab_performanceImprovement_riskScoreTooltip: 'Range: 1-10000',
    driverPerformanceFunctionTab_performanceImprovement_eventsTooltip: 'Range: 1-10000',
    driverPerformanceFunctionTab_performanceImprovement_totalDistanceTooltip: 'Range: 1-10000',
    driverPerformanceFunctionTab_performanceImprovement_miles: 'miles',
    driverPerformanceFunctionTab_performanceImprovement_kilometers: 'km'
};